// Version : 0.0.2
// Author : AGALYA
// LAST EDIT DONE BY : Shiyam
// LastEdit : added version
// MODFIED DATA : 23-09-2025

import overdueReportActionTypes from './over-due-report.types';

/** ***************** GET OVERDUE REPORT DETAILS START *********************** */
export const getoverdueReportDetailsStart = (getData: any) => ({
	type: overdueReportActionTypes.GET_OVERDUE_REPORT_LIST_START,
	payload: getData,
});

export const getoverdueReportDetailsSuccess = (successData: any) => ({
	type: overdueReportActionTypes.GET_OVERDUE_REPORT_LIST_SUCCESS,
	payload: successData,
});

export const getoverdueReportDetailsFailure = (failureData: any) => ({
	type: overdueReportActionTypes.GET_OVERDUE_REPORT_LIST_FAILURE,
	payload: failureData,
});

export const getoverdueReportDetailsResponseResetStart = () => ({
	type: overdueReportActionTypes.GET_OVERDUE_REPORT_LIST_RESPONSE_RESET,
});

export const getoverdueReportDetailsResponseChanged = () => ({
	type: overdueReportActionTypes.GET_OVERDUE_REPORT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET OVERDUE REPORT DETAILS END *********************** */
